import { all } from 'redux-saga/effects';
import training from './training';
import templateTraining from './templateTraining';

export default function* rootSaga() {
  yield all([...training, ...templateTraining]);
}
